import { IAppState } from '../../common/state';

export const selectSuburbanBuildersProjects = (state: IAppState) => {
  return state.suburbanBuildersProjects;
};
